// Enhanced product card variant selection system
document.addEventListener('DOMContentLoaded', function() {
  // Listen for clicks on product card links
  document.addEventListener('click', function(event) {
    const productCardLink = event.target.closest('.product-card-link');
    
    if (productCardLink) {
      const productId = productCardLink.dataset.productId;
      const variantId = productCardLink.dataset.variantId;
      
      if (productId && variantId) {
        const collectionContext = getCollectionContext();
        const variantInfo = {
          productId: productId,
          variantId: variantId,
          timestamp: Date.now(),
          collectionHandle: collectionContext.handle,
          isSingleColorCollection: collectionContext.isSingleColor
        };
        
        sessionStorage.setItem('clickedVariant', JSON.stringify(variantInfo));
      }
    }
  });

  // On product pages, check if we should load a specific variant
  if (window.location.pathname.includes('/products/')) {
    handleProductPageVariantSelection();
  }
});

function getCollectionContext() {
  // Use global collection context if available, otherwise fallback to detection
  if (window.collectionContext) {
    return {
      handle: window.collectionContext.handle,
      isSingleColor: window.collectionContext.isSingleColor,
      colorName: window.collectionContext.colorName
    };
  }
  
  // Fallback detection for cases where collection context isn't set
  const context = {
    handle: null,
    isSingleColor: false,
    colorName: null
  };
  
  // Check if we're on a collection page
  const pathParts = window.location.pathname.split('/');
  if (pathParts.includes('collections') && pathParts.length >= 3) {
    context.handle = pathParts[pathParts.indexOf('collections') + 1];
    
    // Check if it's a single color collection based on handle or URL
    context.isSingleColor = isSingleColorCollection(context.handle);
  }
  
  return context;
}

function isSingleColorCollection(collectionHandle) {
  if (!collectionHandle) return false;
  
  // Define patterns that indicate single-color collections
  const singleColorPatterns = [
    /^(white|black|red|blue|green|yellow|pink|purple|orange|grey|gray)$/i,
    /^color-/i,
    /-(white|black|red|blue|green|yellow|pink|purple|orange|grey|gray)$/i,
    /^(cool-white|warm-white|ice-blue|light-pink|light-green|dark-blue)$/i,
    /^(multi-color|multicolor)$/i
  ];
  
  return singleColorPatterns.some(pattern => pattern.test(collectionHandle));
}

function handleProductPageVariantSelection() {
  const storedVariant = sessionStorage.getItem('clickedVariant');
  
  if (storedVariant) {
    try {
      const variantData = JSON.parse(storedVariant);
      const currentTime = Date.now();
      const fiveMinutes = 5 * 60 * 1000;
      
      if (currentTime - variantData.timestamp > fiveMinutes) {
        sessionStorage.removeItem('clickedVariant');
      } else {
        const currentProductId = extractProductIdFromPage();
        
        if (currentProductId && currentProductId === variantData.productId) {
          sessionStorage.removeItem('clickedVariant');
          
          // Check if we should respect the clicked variant or use default
          if (!variantData.isSingleColorCollection) {
          selectVariantById(variantData.variantId);
          return;
          }
        }
      }
    } catch (error) {
      console.warn('Error processing stored variant:', error);
      sessionStorage.removeItem('clickedVariant');
    }
  }

  // If no valid stored variant or single color collection, select the default variant
  selectDefaultVariant();
}

function selectVariantById(variantId) {
  // Fast method: directly select variant options without AJAX
  waitForVariantSelectors((variantSelectors) => {
    fetchVariantByIdAndSelect(variantId);
  });
}

function fetchVariantByIdAndSelect(variantId) {
  const currentUrl = new URL(window.location);
  const productHandle = currentUrl.pathname.split('/products/')[1]?.split('/')[0];
  
  if (!productHandle) return;
  
  // Fetch product data to get variant information
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(productData => {
      if (productData && productData.variants) {
        const targetVariant = productData.variants.find(v => v.id == variantId);
        if (targetVariant) {
          selectVariantOptions(targetVariant);
        } else {
          // Fallback to default variant if target not found
          selectDefaultVariant();
        }
      }
    })
    .catch(error => {
      console.warn('Error fetching variant data:', error);
      selectDefaultVariant();
    });
}

function selectVariantOptions(variantData) {
  waitForVariantSelectors((variantSelectors) => {
    try {
    // Get all option selectors
    const selects = variantSelectors.querySelectorAll('select');
    const radioGroups = variantSelectors.querySelectorAll('fieldset');
    
      // Select dropdown options
    selects.forEach((select, index) => {
      const optionValue = variantData[`option${index + 1}`];
      
      if (optionValue) {
          const optionToSelect = Array.from(select.options).find(opt => 
            opt.value === optionValue || 
            normalizeOptionValue(opt.value) === normalizeOptionValue(optionValue)
          );
          
          if (optionToSelect) {
            selectOption(select, optionToSelect);
        }
      }
    });
    
      // Select radio/swatch options
    radioGroups.forEach((fieldset, index) => {
      const optionValue = variantData[`option${index + 1}`];
      
      if (optionValue) {
          const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(r => 
            r.value === optionValue || 
            normalizeOptionValue(r.value) === normalizeOptionValue(optionValue)
          );
        
        if (radio) {
          selectRadio(fieldset, radio);
        }
      }
    });
      
      // Update product info
      updateProductInfo(variantData);
      
    } catch (error) {
      console.warn('Error selecting variant options:', error);
    }
  });
}

function normalizeOptionValue(value) {
  if (!value) return '';
  
  // Handle special characters and normalize for comparison
  return value.toString()
    .toLowerCase()
    .trim()
    .replace(/['"]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"');
}

function selectDefaultVariant() {
  waitForVariantSelectors((variantSelectors) => {
    const selectedVariantScript = document.querySelector('script[data-selected-variant]');
    let currentVariant = null;
    
    if (selectedVariantScript) {
      try {
        currentVariant = JSON.parse(selectedVariantScript.textContent);
      } catch (e) {
        console.warn('Error parsing current variant:', e);
      }
    }
    
    // Check if current variant is already a default variant
    if (currentVariant && isDefaultVariant(currentVariant)) {
      selectVariantOptions(currentVariant);
      return;
    }
    
    // Try to find and select the default variant
    findAndSelectDefaultVariant();
  });
}

function findAndSelectDefaultVariant() {
  const currentUrl = new URL(window.location);
  const productHandle = currentUrl.pathname.split('/products/')[1]?.split('/')[0];
  
  if (!productHandle) {
    return;
  }
  
  // Fetch the product data to get all variants
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(productData => {
      if (productData && productData.variants) {
        // Find the default variant using improved logic
        const defaultVariant = findDefaultVariant(productData.variants);
        
        if (defaultVariant) {
          selectVariantOptions(defaultVariant);
        } else {
          // Fallback logic
          handleFallbackVariantSelection(productData.variants);
        }
      }
    })
    .catch(error => {
      console.warn('Error fetching product data:', error);
    });
}

function findDefaultVariant(variants) {
  // Priority 1: Check for explicit default_variant metafield
  let defaultVariant = variants.find(variant => {
    if (!variant.metafields) return false;
    
    // Check different metafield structures
    return (
      variant.metafields.default_variant === 1 || 
      variant.metafields.default_variant === "1" ||
      variant.metafields.default_variant === true ||
      (variant.metafields.custom && (
        variant.metafields.custom.default_variant === 1 || 
        variant.metafields.custom.default_variant === "1" ||
        variant.metafields.custom.default_variant === true
      ))
    );
  });
  
  if (defaultVariant) return defaultVariant;
  
  // Priority 2: Check for any metafield containing "default" with value 1 or true
  defaultVariant = variants.find(variant => {
    if (!variant.metafields) return false;
    
    try {
      const metafieldsStr = JSON.stringify(variant.metafields).toLowerCase();
      return metafieldsStr.includes('default') && 
             (metafieldsStr.includes('"1"') || metafieldsStr.includes('true'));
    } catch (e) {
      return false;
    }
  });
  
  return defaultVariant;
}

function handleFallbackVariantSelection(variants) {
  // Get current variant from page
          const selectedVariantScript = document.querySelector('script[data-selected-variant]');
  
          if (selectedVariantScript) {
            try {
              const currentVariant = JSON.parse(selectedVariantScript.textContent);
      
      // If current variant is Multi-Color, keep it
      if (currentVariant && isMultiColorVariant(currentVariant)) {
        selectVariantOptions(currentVariant);
        return;
              }
            } catch (e) {
      console.warn('Error parsing current variant for fallback:', e);
            }
          }
          
  // Look for Multi-Color variant as fallback
  const multiColorVariant = variants.find(variant => 
    isMultiColorVariant(variant)
  );
  
  if (multiColorVariant) {
    selectVariantOptions(multiColorVariant);
          }
  // If no Multi-Color variant, leave current selection as is
}

function isDefaultVariant(variant) {
  if (!variant || !variant.metafields) return false;
  
  // Check explicit default metafields
  if (variant.metafields.default_variant === 1 || 
      variant.metafields.default_variant === "1" ||
      variant.metafields.default_variant === true) {
    return true;
  }
  
  if (variant.metafields.custom && 
      (variant.metafields.custom.default_variant === 1 || 
       variant.metafields.custom.default_variant === "1" ||
       variant.metafields.custom.default_variant === true)) {
    return true;
  }
  
  // Check for any "default" metafield with value 1 or true
  try {
  const metafieldsStr = JSON.stringify(variant.metafields).toLowerCase();
    return metafieldsStr.includes('default') && 
           (metafieldsStr.includes('"1"') || metafieldsStr.includes('true'));
  } catch (e) {
    return false;
  }
}

function isMultiColorVariant(variant) {
  if (!variant) return false;
  
  const multiColorValues = [
    'multi-color', 'multicolor', 'multi color',
    'rainbow', 'mixed', 'assorted', 'various'
  ];

  // Check all option values
  for (let i = 1; i <= 3; i++) {
    const optionValue = variant[`option${i}`];
    if (optionValue && multiColorValues.includes(optionValue.toLowerCase())) {
      return true;
    }
  }
  
  return false;
}

function selectOption(select, option) {
  if (!select || !option) return;
  
  try {
    // Add loading state
    select.classList.add('loading');
    select.disabled = true;
    
    // Clear previous selection
    Array.from(select.options).forEach(opt => {
      opt.removeAttribute('selected');
      opt.selected = false;
  });
  
    // Select new option
    option.selected = true;
    option.setAttribute('selected', 'selected');
    select.value = option.value;
    
    // Trigger change event
    select.dispatchEvent(new Event('change', { bubbles: true }));
    
    // Remove loading state after a short delay
    setTimeout(() => {
      select.classList.remove('loading');
      select.disabled = false;
    }, 600);
  } catch (error) {
    console.warn('Error selecting option:', error);
  }
}

function selectRadio(fieldset, radio) {
  if (!fieldset || !radio) return;
  
  try {
    // Uncheck all radios in this fieldset
    const radios = fieldset.querySelectorAll('input[type="radio"]');
    radios.forEach(r => {
    r.checked = false;
    r.removeAttribute('checked');
  });
  
    // Check the target radio
  radio.checked = true;
  radio.setAttribute('checked', 'checked');
  
    // Update the displayed selected value
    const selectedValueSpan = fieldset.querySelector('[data-selected-value]');
    if (selectedValueSpan) {
      selectedValueSpan.textContent = radio.value;
    }
    
    // Trigger change event
  radio.dispatchEvent(new Event('change', { bubbles: true }));
  } catch (error) {
    console.warn('Error selecting radio:', error);
  }
}

function updateProductInfo(variantData) {
  // Update the selected variant script
  const selectedVariantScript = document.querySelector('script[data-selected-variant]');
  if (selectedVariantScript) {
    try {
      selectedVariantScript.textContent = JSON.stringify(variantData);
    } catch (error) {
      console.warn('Error updating variant script:', error);
    }
  }
  
  // Trigger product form update if available
  const productForm = document.querySelector('product-form');
  if (productForm && typeof productForm.onVariantChange === 'function') {
    try {
      productForm.onVariantChange();
    } catch (error) {
      console.warn('Error triggering product form update:', error);
    }
  }
}

function extractProductIdFromPage() {
  // Try multiple methods to get product ID
  const productInfo = document.querySelector('product-info');
  if (productInfo && productInfo.dataset.productId) {
    return productInfo.dataset.productId;
  }
  
  const productForm = document.querySelector('product-form');
  if (productForm && productForm.dataset.productId) {
    return productForm.dataset.productId;
  }
  
  // Extract from URL as fallback
  const pathParts = window.location.pathname.split('/');
  const productIndex = pathParts.indexOf('products');
  if (productIndex !== -1 && pathParts[productIndex + 1]) {
    // This returns handle, not ID, but can be used for comparison
    return pathParts[productIndex + 1];
  }
  
  return null;
}

function waitForVariantSelectors(callback, maxAttempts = 50) {
  let attempts = 0;
  
  const checkForVariantSelectors = () => {
    const variantSelectors = document.querySelector('variant-selects, .product-form__input, .product-form__buttons');
    
    if (variantSelectors || attempts >= maxAttempts) {
      callback(document);
    } else {
      attempts++;
      setTimeout(checkForVariantSelectors, 100);
    }
  };
  
  checkForVariantSelectors();
}

// Export functions for testing/debugging
window.productVariantUtils = {
  isSingleColorCollection,
  isDefaultVariant,
  isMultiColorVariant,
  normalizeOptionValue,
  selectDefaultVariant
}; 